import styled from "styled-components";


export const Container = styled.main`
  .pg_overlay {
    position: fixed;
    inset: 0;
    background-color: rgba(0, 0, 0, 0.6);
    z-index: 9999;
  }

  .inner{
    padding-top: 100px;
    padding-bottom: 100px;

    .btn_done{
      width: 100%;
      height: 46px;
      margin: 48px 0 0;
      border-radius: 6px;
    }
  }


  @media screen and (min-width: 501px) {
    section{
      width: 360px;
      margin: 0 auto;
    }
  }

  @media (max-width: 500px) {
    section{
      width: 100%;
    }
  }
`